var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-view"},[_c('l-map',{staticStyle:{"height":"100%"},attrs:{"zoom":_vm.zoom,"center":_vm.center}},[_c('l-tile-layer',{attrs:{"url":_vm.url}}),_c('l-marker',{attrs:{"lat-lng":_vm.coordinates,"icon":_vm.markerIcon}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }